import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const USER_API = environment.apiUrl + 'kyc-verification';
import { TokenStorageService } from './token-storage.service';
@Injectable()

@Injectable({
    providedIn: 'root'
})
export class KycService {

    authtoken: string;
    private httpOptions;
    private options;
    constructor(private http: HttpClient, private token: TokenStorageService) {
    }
    generateOtp(data: any): Observable<any> {
        return this.http.post(USER_API + '/generate-otp', data);
    }
    verifyOtp(data: any): Observable<any> {
        return this.http.post(USER_API + '/verify-otp', data);
    }
    panCardVerification(data: any): Observable<any> {
        return this.http.post(USER_API + '/pan-verify', data);
    }
    bankVerification(data: any): Observable<any> {
        return this.http.post(USER_API + '/bank-verify', data);
    }
    updateBank(id, data: any): Observable<any> {
        return this.http.put(USER_API + '/bank-verify/' + id, data);
    }
    getUserKycBankList(id, query): Observable<any> {
        return this.http.get(USER_API + "/bank-details/" + id + "?" + query);
    }
}